import styled from 'styled-components'
import Typography from '@material-ui/core/Typography'
import { FavoriteBorder, Accessibility, CheckCircle, Warning, InvertColors, Chat, HowToReg, PhoneRounded } from '@material-ui/icons'

export const Title = styled(Typography)`
  color: #818181;
  &&& {
    font-size: 1.6rem;
    line-height: 1.8rem;
    padding-bottom: 0.9rem;
    margin: 0;
    margin-left: 2rem;
    position: relative;
    padding-top: 1rem;
    @media (max-width: 600px) {
      padding-top: 0.5rem;
    }
  }
`

export const StyledOverview = styled(Typography)`
  &&& {
    font-size: 1.6rem;
    line-height: 1.8rem;
    padding-bottom: 0.9rem;
    margin: 0;
    position: relative;
    padding-top: 1rem;
    @media (max-width: 600px) {
      padding-top: 0.5rem;
    }
  }
`

export const OverviewPosition = styled.div`
    top: 16px;
    position: relative;
`
export const StyledFavoriteBorder = styled(FavoriteBorder)`
  &&& {
  vertical-align: middle;
  }
`
export const StyledAccessibility = styled(Accessibility)`
  &&& {
  vertical-align: middle;
  }
`

export const StyledChat = styled(Chat)`
  &&& {
  vertical-align: middle;
  }
`

export const StyledCheckCircle = styled(CheckCircle)`
  &&& {
  vertical-align: middle;
  }
`
export const StyledWarning = styled(Warning)`
  &&& {
  vertical-align: middle;
  }
`
export const StyledInvertColors = styled(InvertColors)`
  &&& {
  vertical-align: middle;
  }
`
export const StyledHowToReg = styled(HowToReg)`
  &&& {
  vertical-align: middle;
  }
`
export const StyledPhone = styled(PhoneRounded)`
  &&& {
  vertical-align: middle;
  }
`
export const StyledSpan = styled.span`margin-left: 4rem;`

export const StyledActionSpan = styled.span`margin-left: 4rem;`

export const ChargennummerSpan = styled.span`margin-left: 3.3rem;`

export const Impressum = styled.div`
    margin-left: 16px;
    display: inline;
`

export const PrivacySection = styled.div`
    margin-left: 16px;
    display: inline;
`

export const LinkContainer = styled.div`
    margin: 5px;
    text-align: center;
    padding: 1rem;
    margin-right: 4rem;
    margin-top: 2rem;
`

export const ClickableDiv = styled.div`
  &&& {
    font-size: 1.6rem;
    line-height: 1.8rem;
    padding-bottom: 0.9rem;
    margin: 0;
    margin-left: 2rem;
    position: relative;
    padding-top: 1rem;
    @media (max-width: 600px) {
      padding-top: 0.5rem;
    }
  }
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`
